import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IModule, IPromise, IQService} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {Kontekst} from "felles/tjenester/Kontekst";
import {SystemmeldingRessurs} from "felles/tjenester/ressurser/SystemmeldingRessurs";
import SystemMeldingModell = l.SystemMeldingModell;
import {dekodHexHtmlEntiteter} from "felles/stoettefunk/htmlentitet";
import {Debugger} from "debug";
import {DetteErNyttDialogInterface} from "felles/tjenester/modulspesifikke/DetteErNyttDialog";

const css = require('./detteErNyttDialog.scss');

const debug: Debugger = require('debug')('DetteErNyttDialog');

/**
 * Teste lokalt:
 * Legg inn verdien https://nyheter.styreplan.no inne i "Administrasjon" -> "Meldinger",
 * med meldingstype "Dette er nytt: for styreplan-ansatte (testing)"
 * Gå til Hjem og så kommer dialogen opp med meldingssiden
 */
export class DetteErNyttDialog implements DetteErNyttDialogInterface {
    static regNavn = "felles.tjenester.modulspesifikke.DetteErNyttDialog";

    static registrerDialog(angular: IModule) {
        angular
            .service(
                DetteErNyttDialog.regNavn,
                [
                    regNavn.md.$mdDialog,
                    regNavn.ng.$q,
                    SystemmeldingRessurs.regNavn,
                    Kontekst.regNavn,
                    DetteErNyttDialog
                ]
            )
            .controller(DetteErNyttDialogKontroller.regNavn, DetteErNyttDialogKontroller.forInjisering())
    }

    constructor(private $mdDialog: angular.material.IDialogService,
                private $q: IQService,
                private meldingRes: SystemmeldingRessurs,
                private kontekst: Kontekst) {
        this.harKjørtFerdig = $q.defer<boolean>();
    }
    private harKjørtFerdig: angular.IDeferred<boolean>;

    private dialogKonfigurasjon: angular.material.IDialogOptions = {
        template: require('./detteErNyttDialog.html'),
        controller: DetteErNyttDialogKontroller.regNavn,
        bindToController: true,
        controllerAs: '$ctrl',
    };

    erFerdig(): IPromise<boolean> {
        return this.harKjørtFerdig.promise;
    }

    /**
     * Viser dette er nytt dialog så fort vi har fått
     * meldingen fra server (hvis det er en melding som skal vises)
     */
    visDialog(): void {
        this.kontekst.erLastetFraServer().then(() => {
            let type = this.hentBrukersMeldingstype();
            debug('visDialog for type ' + l.Meldingstype[type])

            this.meldingRes.hentAktivForType(type).then((sisteMelding) => {
                // Finnes ingen melding vi kan vise
                if (sisteMelding == null) {
                    debug('finnes ingen melding å vise');
                    this.harKjørtFerdig.resolve(false);
                    return;
                }

                // Test-melding, skal alltid vises (hentes kun for admins, så trygt å alltid vise)
                if (sisteMelding.meldingstype == l.Meldingstype.detteErNyttForTesting) {
                    debug('viser testmelding');
                    this.åpneDialog(sisteMelding);
                    return;
                }

                // Har sett det før
                if (sisteMelding.id == this.kontekst.brukervalg().detteErNyttSisteSett) {
                    debug('har sett meldingen før', sisteMelding);
                    this.harKjørtFerdig.resolve(false);
                    return;
                }

                // Marker som vist, og vis
                this.kontekst.oppdaterBrukervalg({detteErNyttSisteSett: sisteMelding.id})
                  .then(() => {
                      debug('meldingen markert som vist, nå åpnes dialogen');
                      this.åpneDialog(sisteMelding);
                  });
            });
        })
    }

    private åpneDialog(melding: SystemMeldingModell) {
        return this.$mdDialog
          .show({
              ...this.dialogKonfigurasjon,
              ...{
                  locals: {melding: melding}
              }
          })
          .finally(() => {
              debug('ferdig å vise dialog');
              this.harKjørtFerdig.resolve(true)
          });
    }

    private hentBrukersMeldingstype() {
        if (this.kontekst.inneharTilgangsrolle(l.TilgansrollerBruker.administrator)) {
            return l.Meldingstype.detteErNyttForTesting;
        }
        if (this.kontekst.inneharTilgangsrolleINoenGruppe(l.TilgangsrolleMedlem.skrive)) {
            return l.Meldingstype.detteErNyttForAdmin;
        }
        return l.Meldingstype.detteErNyttForMedlem;
    }
}

export class DetteErNyttDialogKontroller implements MdDialogController {
    static regNavn = "wm.dashboard.modale.detteErNyttDialog.DetteErNyttDialogKontroller";

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            DetteErNyttDialogKontroller
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {}

    private melding: SystemMeldingModell; // satt via locals

    $onInit(){}

    visUrl() {
        return dekodHexHtmlEntiteter(this.melding.melding);
    }

    lukk() {
        this.$mdDialog.cancel();
    }
}
